import { useMutation } from '@apollo/client';
import { useTranslation } from 'react-i18next';
import { useNotifications, type ApiOptions } from '../helpers';
import { ExportDataSourceDocument } from './export.generated';

export const useExportDataSource = (options: ApiOptions<typeof ExportDataSourceDocument> = {}) => {
  const { t } = useTranslation();
  return useMutation(ExportDataSourceDocument, {
    ...useNotifications(ExportDataSourceDocument, {
      failure: t('api.common.error_generic'),
      success: t('api.data_sources.export_success'),
    }),
    ...options,
  });
};
